





















































































import {Component, Prop, PropSync, Watch} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {PriorityRuleFilter} from "@/store/rules/priority_rules/types";
import {SelectWings, ToggleWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {MsgTransports} from "@/store/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings}})
export default class PriorityRulesFilter extends BaseFilter<PriorityRuleFilter>{
  @PropSync('show') is_show!: boolean;
  @Prop() transport!: MsgTransports;
  @Getter("priorityList") priorityList: any;
  @Getter("smsTemplates") smsTemplatesList: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getSmsTemplates") actionGetSmsTemplates: any;
  @Action("getPriorityRules") actionGetPriorityRules: any;

  defaultFilter(): PriorityRuleFilter {
    return {
      originator: undefined,
      partner: undefined,
      template: undefined,
      priority: undefined,
    };
  }

  storageItemName(): string {
    return `${this.transport.toLowerCase()}PriorityRulesFilter`;
  }

  params = {transport: this.transport.toString()};
  partnersList: any = []
  originatorsList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    let newFilter = this.filter.partner ? {...this.params, partner: this.filter.partner, ...filter} : {...this.params, ...filter}
    const items = await this.actionGetOriginators(newFilter);
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async created() {
    // this.actionGetSmsTemplates({is_active:1});
    this.filtered();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.originator) this.originatorsList = await this.actionGetOriginators({originator: this.filter.originator});
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "The rule for changing the priority of sending",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetPriorityRules({
        filter : this.filter,
        transport: this.transport.toLowerCase()
      });
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  @Watch('filter.partner')
  onPartnerChanged(val?: string, oldVal?: string) {
    if (val) {
      this.actionGetSmsTemplates({is_active:1, partner: val});
    }
    if ((oldVal && val !== oldVal) || !val) {
      this.unsetFilter('template');
      this.unsetFilter('originator');
    }
  }
}
